import React from 'react';
import PropTypes from "prop-types";
import Icon from 'components/Icon';
import "./Collapse.scss";

class Collapse extends React.PureComponent {
    static propTypes = {
        expandLabel: PropTypes.string.isRequired,
        collapseLabel: PropTypes.string.isRequired,
        children: PropTypes.node,
    }

    state = {
        isExpanded: false,
        height: 0,
    };

    componentDidMount() {
        this.contentRef = this.contentRef || null;
    }

    toggleExpand = () => {
        this.setState(
            prevState => ({
                isExpanded: !prevState.isExpanded,
            }),
            () => {
                this.setState({
                    height: this.state.isExpanded
                        ? this.contentRef.scrollHeight
                        : 0,
                });
            }
        );
    };

    render() {
        const { expandLabel, collapseLabel, children } = this.props;
        const { isExpanded, height } = this.state;

        return (
            <div className="collapse">
                <div className="collapse__toggle-btn-holder">
                    <button
                        onClick={this.toggleExpand}
                        aria-expanded={isExpanded}
                        className="collapse__toggle-btn"
                    >
                        {isExpanded ? collapseLabel : expandLabel}
                        <Icon 
                            icon={isExpanded  ? "minus-circle" : "plus-circle"}
                            className="collapse__toggle-btn-icon"
                        />
                    </button>
                </div>
                <div
                    className="collapse__content"
                    ref={el => (this.contentRef = el)}
                    style={{
                        overflow: 'hidden',
                        transition: 'height 0.3s ease',
                        height: `${height}px`,
                    }}
                    aria-hidden={!isExpanded}
                >
                    <div className="collapse__indent-wrapper">{children}</div>
                </div>
            </div>
        );
    }
}

export default Collapse;



// WEBPACK FOOTER //
// ./src/components/Collapse/Collapse.jsx